import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=7c6ae4ac"
import script from "./TopMenu.ts?vue&type=script&lang=ts&external"
export * from "./TopMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports